import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { CheckAccountModel } from './model/check-account-model.interface';
import { CheckAccountModelImpl } from './model/check-account-model';
import { GuestToMasterService } from './service/guest-to-master-service.interface';
import { GuestToMasterServiceImpl } from './service/guest-to-master-service';
import { CheckAccountDto } from './service/guest-to-master-repository.interface';
import { CheckAccountDtoImpl } from './repository/check-account-dto';
import { CheckAccountApiImpl } from './repository/api/check-account-api';
import { CheckAccountApi } from './repository/api/check-account-api.interface';

export const guestToMasterModule = new ContainerModule((bind) => {
  bind(CheckAccountApi).to(CheckAccountApiImpl);
  bind(CheckAccountDto).to(CheckAccountDtoImpl);
  bind(CheckAccountModel).to(CheckAccountModelImpl);
  bind(GuestToMasterService).to(GuestToMasterServiceImpl);
});
